import React, {Component} from 'react';
import '../css/Page.css';

class PageOffertaTecnica extends Component {

    render() {
        return (
                <div className="page">
                    <article>

                        <h3>Servizio Offerta economicamente pi&ugrave; vantaggiosa ai sensi dell&rsquo;art. 83 del D.Lgs. 163/06 e smi.</h3>
                        <p>L&rsquo;offerta economicamente pi&ugrave; vantaggiosa &egrave; il criterio che implica necessariamente la presentazione da parte delle imprese di un offerta tecnica dove si indicano delle variazioni progettuali o delle proposte migliorative al progetto posto a base di gara.
                            <br/>All&rsquo;interno dell&rsquo;Areamultiservice &egrave; nato un network di professionisti che condivide in maniera integrata, diverse e molteplici competenze, agisce ed interagisce fornendo alle Imprese gli strumenti per ottimizzare i processi aziendali ed ottenere soddisfacenti performances nel settore delle Gare di Appalto.
                            L&rsquo;esperienza maturata, la capacit&agrave; di modellare il servizio alle esigenze di ogni Impresa e la presenza in organico di qualificati partner, quali Ingegneri di vari rami, Architetti, Periti, Geometri e Geologi, ci consente di offrire, nell&rsquo;ambito delle gare di appalto con Offerta Economicamente pi&ugrave; Vantaggiosa, un servizio di consulenza efficiente, di qualit&agrave;, curato sotto ogni aspetto e soprattutto <strong>VINCENTE</strong> .</p>
                        <p>L&rsquo;espletamento del servizio avviene:</p>
                        <ol>
                            <li>Supporto tecnico alla scelta della gara;</li>
                            <li>Analisi del disciplinare di gara;</li>
                            <li>Studio del progetto a base di gara;</li>
                            <li>Scelta e valutazione tecnico-economica con l&rsquo;Impresa;</li>
                            <li>Redazione Offerta Tecnica;</li>
                            <li>Analisi dell&rsquo;equilibrio vincente tra ribasso e migliorie;</li>
                            <li>Confronto delle idee proposte con l&rsquo;Impresa;</li>
                            <li>Conclusione degli elaborati relazionali e grafici;</li>
                            <li>Invio mezzo mail o altro in tempo utile per partecipare alla gara.</li>
                        </ol>

                        <p>Per richiedere il servizio vi preghiamo di inviare i seguenti documenti tramite mail:</p>
                        <ul>
                            <li>Copia della CCIAA;</li>
                            <li>Copia del documento d&rsquo;identit&agrave; del L.R.;</li>
                            <li>Copia del certificato SOA (se ne &egrave; in possesso);</li>
                            <li>Recapiti telefonici, fax email e PEC;</li>
                            <li>Bando e disciplinare di gara.</li>
                        </ul>
                        <p>Mail:&nbsp;<a href="mailto:info@areamultiservice.it">info@areamultiservice.it</a> e/o <a href="mailto:serviziappalti@libero.it">serviziappalti@libero.it</a></p>
                        <p>Per ulteriori informazioni contattare il responsabile Ufficio Gare al numero <strong>329/8177540</strong>.</p>
                    </article>
                </div>
        );
    }
}

export default PageOffertaTecnica;


// WEBPACK FOOTER //
// ./src/page/js/PageOffertaTecnica.js